import type { MouseEvent, PointerEvent } from "react";

export function pressHandlers(action: () => void) {
  // Secondary touches do not reliably emit click while the joystick is held.
  return {
    onPointerDown: (event: PointerEvent<HTMLButtonElement>) => {
      if (event.button !== 0) return;
      event.preventDefault();
      action();
    },
    onClick: (event: MouseEvent<HTMLButtonElement>) => {
      if (event.detail === 0) action();
    },
  };
}
